import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a wifi icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WifiIcon width={12} />
 */
const WifiIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M2.99997 10.3999C2.62997 10.3999 2.24997 10.2499 1.97997 9.9599C1.44997 9.3899 1.47997 8.4999
            2.03997 7.9799C7.05997 3.2899 16.93 3.2899 21.95 7.9799C22.52 8.5099 22.55 9.3899 22.02 9.9599C21.49
            10.5299 20.6 10.5599 20.04 10.0299C16.06 6.3099 7.93997 6.3099 3.94997 10.0299C3.68997 10.2799
            3.33997 10.3999 2.99997 10.3999ZM18.12 13.8399C18.59 13.2199 18.46 12.3499 17.85 11.8799C14.63
            9.4499 9.38997 9.4499 6.15997 11.8799C5.53997 12.3499 5.41997 13.2199 5.88997 13.8399C6.35997
            14.4599 7.22997 14.5799 7.84997 14.1099C10.06 12.4399 13.95 12.4399 16.16 14.1099C16.41 14.2999
            16.71 14.3899 17 14.3899C17.42 14.3999 17.84 14.2099 18.12 13.8399ZM11.29 19.2899C11.68 19.6799
            12.32 19.6799 12.7 19.2899L14.29 17.6999C14.68 17.3099 14.65 16.7599 14.22 16.4699C12.88 15.5699
            11.13 15.5699 9.77997 16.4699C9.34997 16.7599 9.31997 17.3099 9.70997 17.6999L11.29 19.2899Z`}
        />
    </SvgIcon>
)

WifiIcon.defaultProps = defaultProps

export { WifiIcon }
